import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Category } from '@core/model/category.model';
import { Product } from '@core/model/product.model';
import { Paginated } from '@core/model/paginated.model';
import { Subject } from 'rxjs';
import { CategoryService, ProductService, UnityService } from '@app/core';
import { FileService } from '@core/service/file.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment.prod';
import { Unidad } from '@app/core/model/unidad.model';

@Component({
  selector: 'app-product-create',
  templateUrl: './product-create.component.html',
  styleUrls: ['./product-create.component.css']
})
export class ProductCreateComponent implements OnInit {
  productsForm: FormGroup;
  categories: Category[];
  products: Product[];
  product: any = {};
  unidades: Unidad[];
  isLoading = false;
  // unidades de la vista

  // subir foto
  fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  imagenURL: any = {};
  progress = 0;

  pager = {};
  pageOfItems: any = [];

  productos: Paginated;
  private searchTermStream = new Subject<string>();
  currentSearchTerm: string = null;
  @Input() producto_id: string;
  @Input() estado: boolean;
  @Input() titulo: string;

  constructor(
    private formBuilder: FormBuilder,
    private categoryService: CategoryService,
    private productService: ProductService,
    private fileService: FileService,
    private unidadService: UnityService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.createForm();
    this.listCategorys();
    this.listarUnidades();
    // this.listProducts();
    if (this.estado === true) {
      this.editProduct(this.producto_id);
    }
  }

  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }

  preview() {
    // Show preview
    const mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = _event => {
      this.previewUrl = reader.result;
    };
  }

  subirFoto() {
    const formData = new FormData();
    formData.append('file', this.fileData);
    this.fileUploadProgress = '0%';
    this.fileService.sendFile(formData).subscribe(
      (event: HttpEvent<any>) => {
        //    console.log(this.imagenURL);
        switch (event.type) {
          case HttpEventType.Sent:
            console.log('Request has been made!');
            break;
          case HttpEventType.ResponseHeader:
            console.log('Response header has been received!');
            break;
          case HttpEventType.UploadProgress:
            this.fileUploadProgress =
              Math.round((event.loaded / event.total) * 100) + '%';
            this.progress = Math.round((event.loaded / event.total) * 100);
            console.log(`Uploaded! ${this.progress}%`);
            break;
          case HttpEventType.Response:
            this.fileUploadProgress = '';
            this.imagenURL = event.body;
            console.log('archivo creado con exito!', event.body);
            setTimeout(() => {
              this.progress = 0;
            }, 1500);
        }
      },
      error => {
        console.log(error.error);
      }
    );
  }

  listCategorys() {
    this.categoryService.getCategoriasHabilitdas().subscribe(
      data => {
        this.categories = data;
        console.log(data);
      },
      error1 => {
        console.log(error1.error);
      }
    );
  }
  listarUnidades() {
    this.unidadService.getAll().subscribe(
      data => {
        this.unidades = data;
        console.log(data);
      },
      error1 => {
        console.log(error1.error);
      }
    );
  }

  createForm() {
    this.productsForm = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      descripcion: [''],
      codigo: ['', [Validators.required]],
      // foto: ['', [Validators.required]],
      marca: ['', [Validators.required]],
      unidad: ['', [Validators.required]],
      limite_a: ['', [Validators.required]],
      limite_r: ['', [Validators.required]],
      categoria: ['', [Validators.required]],
      precio_venta: ['']
    });
  }

  registerProducts() {
    const formData = new FormData();

    formData.append('file', this.fileData);
    formData.append('producto_id', this.producto_id);
    formData.append('nombre', this.productsForm.value.nombre);
    formData.append('descripcion', this.productsForm.value.descripcion);
    formData.append('codigo', this.productsForm.value.codigo);
    formData.append('marca', this.productsForm.value.marca);
    formData.append('unidad', this.productsForm.value.unidad);
    // formData.append('stock', this.productsForm.value.stock);
    formData.append('limite_a', this.productsForm.value.limite_a);
    formData.append('limite_r', this.productsForm.value.limite_r);
    formData.append('categoria', this.productsForm.value.categoria);
    formData.append('precio_venta', this.productsForm.value.precio_venta);
    if (this.estado === true) {
      formData.append('_method', 'PUT');
      this.isLoading = true;

      this.productService
        .updateProduct(this.producto_id, formData)
        .pipe(
          finalize(() => {
            this.productsForm.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            Swal.fire('Se actualizo correctamente');
            // this.listCategories();
            // this.categoryForm.reset();
            this.estado = false;
            this.productsForm.reset();
            this.activeModal.close(data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    } else {
      this.isLoading = true;

      this.productService
        .create(formData)
        .pipe(
          finalize(() => {
            this.productsForm.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            Swal.fire('Se actualizo correctamente');
            // this.listCategories();
            // this.categoryForm.reset();
            this.estado = false;
            this.productsForm.reset();
            this.activeModal.close(data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    }
  }

  listProducts() {
    this.productService.getAll().subscribe(
      (data: any) => {
        this.products = data;
        console.log(data);
      },
      (error1: any) => {
        console.log(error1.error);
      }
    );
  }

  buscarCategoria(categoria_id: number) {}

  editProduct(id: string) {
    this.productService.getById(id).subscribe(data => {
      console.log(data);

      this.previewUrl = environment.imgUrl + data.foto;
      this.productsForm.setValue({
        nombre: data.nombre,
        descripcion: data.descripcion,
        marca: data.marca,
        codigo: data.codigo,
        unidad: data.unidad_id,
        limite_a: data.limite_a,
        limite_r: data.limite_r,
        precio_venta: data.precio_venta,
        // stock: data.stock,
        categoria: data.categoria_id
        // categoria_id:data.categoria_id
      });
    });
  }
}
